export const PROMPT_CHAINS_SORT_TYPES = {
    alphabetical: 'name',
    created: '-created_at', // most recent first
};

export const PROMPT_CHAINS_TYPES_LABELS = {
    alphabetical: 'Alphabetical',
    created: 'Most Recently Created',
};

export const promptChainSortItems = [
    {
        text: PROMPT_CHAINS_TYPES_LABELS.alphabetical,
        value: PROMPT_CHAINS_SORT_TYPES.alphabetical,
        leadingSelectIcon: true,
    },
    {
        text: PROMPT_CHAINS_TYPES_LABELS.created,
        value: PROMPT_CHAINS_SORT_TYPES.created,
        leadingSelectIcon: true,
    },
];
